import React from 'react';
import { Select } from 'antd';
import { Button } from '@progress/kendo-react-buttons'
import { Input } from '@progress/kendo-react-inputs';
import services from '../../../services';
import { toast } from 'react-toastify';
import InstructionMessage from '../../VidimaModule/Modal/InstructionMessage';
import { data } from 'jquery';
import $ from 'jquery';
import { DownCircleTwoTone } from '@ant-design/icons'


class CriarFluxo extends React.Component {

  state = {
    filters: {
      Filters: null,
      SortBy: "",
      IsSortTypeDESC: false,
      IsPagination: false,
      Page: 2,
      PageSize: 2
    },
    TipoFormulario: ""
  }

  componentDidMount() {
  }

  handleCancel = () => {
    this.props.history.push({
      pathname: "/conta_corrente"
    })
  }

  handleTipoChange(TipoFormulario) {
   
      this.setState({
        TipoFormulario  
      })
   
  }

  handleGraver = async () => {
    const sendObj = { 
      TipoFormulario: $("#tipoformularioinput").val(),
      criadoPor:  window.localStorage.getItem('username')
    }

    await services.apiCall.requestApi('RegrasMovimento/GravarNovoFluxo', sendObj, 'post');
  }

  
  render() {
    return (
      <div className="container-fluid pb-5">
        <div className="p-3 bg-white border rounded mb-2">
          
          <label>Fluxo Vínico</label>
          <div className="row mb-2" id="sticky-seachmenu">
            <div className="col-auto position-relative">
              <Input
                type='text'
                id='tipoformularioinput'
                placeholder="Insira a designação do fluxo vínico"
                className="estatoSelect"
                style={ { width: '500px', height:'34px' } }
                onChange={ (e) => this.handleTipoChange(e) }
              />

            </div>
            <div className="pl-0">
              <Button className="mr-2 btn-ivdp-primary btn-theme k-primary" onClick={() => this.handleGraver()} >Gravar Fluxo</Button>
            </div>
            <div className="col-auto pl-0">
              <Button className="btn-ivdp-secondary" onClick={() => this.handleCancel()} >Cancelar</Button>
            </div>
          </div>
        </div>
      </div>
    )
  }

}

export default CriarFluxo;